import { render, staticRenderFns } from "./RepeatConfigCard.vue?vue&type=template&id=24520cc4"
import script from "./RepeatConfigCard.vue?vue&type=script&lang=js"
export * from "./RepeatConfigCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports